import { filterOptionsType } from "../interfaces/Common";
import { AccountDemographicsDTO, DropDownItem, Facility, IDropDownItem, IRoot } from "../../services/generated";
import moment from "moment";
import { AxiosError } from "axios";

export const IsDefined = (value: any) => {
    return typeof value !== 'undefined';
}

export const IsNonZero = (value: any) => {
    return value !== 0;
}
export const IsNotNull = (value: any) => {
    return !!value
}
export const ToCamelCase = (str: string) => {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

export const ToTitleCase = (str: string) => {
    return str.replace(/\w\S*/g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export const ToLowerCase = (str: string | null | undefined) => {
    let cString = (str) ? str.toLowerCase() : '';
    return cString;
}

export const SpaceAfterComma = (str: string) => {
    let cString = str.split(',').join(', ')
    return cString;
}

export const ConvertHighphenToSpace = (str: string) => {
    let cString = ToTitleCase(str.replace(/-/g, " "));
    return cString;
}

export const CstDate = (date: string | undefined, format: string) => {
    if (date !== null && date !== '' && date !== undefined ) {
        return date === 'N/A' ? 'N/A' : moment(date).format(format);
    } else {
        return '';
    }
}

/**
 * Formats a given date value to Central Standard Time (CST) with the specified format.
 * @param value - The date value to format (string, Date, null, or undefined).
 * @returns The formatted date string in CST, or an empty string if the value is invalid.
 */
export const FormatCentralDateTime = (value: string | Date | null | undefined) => {
    if (!value) return '';

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    // Remove the comma from the formatted date string
    return new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    }).format(date).replace(',', '');
};

export const UtcDate = (date: string | undefined, format: string) => {
  if (date !== null && date !== '' && date !== undefined ) {
      return moment(date).utc().format(format);
  } else {
      return '';
  }
}

export const DateToCST = (date: string, format: string) => {
    let newDate = new Date(date);
    newDate = new Date(newDate.getTime() - ((1 * 60 * 60 * 1000) * 5));
    const cstDate = moment(newDate).utcOffset('America/Regina').format(format);
    return cstDate;
}

export const DateToLocal = (date: string, format: string) => {
    const newDate = moment.utc(date).toDate();
    const localDate = moment(newDate).local().format(format);
    return localDate;
}

export const formatToPhoneNumber = ( number: string | undefined | null ) => {
	if( number ) {
		return number.replace( /\D+/g, "" ).replace( /([0-9]{1,3})([0-9]{3})([0-9]{4}$)/gi, "($1) $2-$3" ); //mask numbers (xxx) xxx-xxxx	
	} else {
		return "";
	}
};

export const toPhoneNumberFormat = ( number: string ) => {
    let convertedNumber: string = '';
	if( number ) {
        convertedNumber = number.replace(/_|-/g, ''); // Remove all hyphens
	}
    return convertedNumber 
};

export const formatAddress = (accountdemography : AccountDemographicsDTO) =>  {

    const parts = [
        ToTitleCase(accountdemography.addressLineOne!),
        ToTitleCase(accountdemography.addressLineTwo!),
        ToTitleCase(accountdemography.city!),
        accountdemography.state,
        accountdemography.postalCode,
    ].filter(Boolean);

    return parts.join(', ');
};

export const formatOptionsKeyValuePair = (nodes: Array<any>, labelKey: string, valueKey: string, showLableAsLabelValue?: boolean) => {
    let options = nodes.map((item) => ({label: showLableAsLabelValue ? item[labelKey] + ' - ' + item[valueKey] : item[labelKey] , value: item[valueKey]}));
    return options;
}

export const getStatusClass = (status: string) => {
    switch (status) {
        case 'COMPLETE':
            return 'status-green';
        case 'IN PROGRESS':
            return 'status-blue';
        case 'NOT STARTED':
            return 'status-black';
        case 'CANCELLED':
            return 'status-red';
        default:
            return 'status-blue';
    }
}

export const sortFilterOptionsType = (options: Array<DropDownItem>) => {
    const sortedOptions = options.slice().sort((a: any, b: any) => a.label.localeCompare(b.label));
    return sortedOptions as Array<filterOptionsType>;
}

export const RemoveAfterDecimal =  (value: string) => {
    // Use a regular expression to remove anything after a decimal point
    return value.replace(/\.\d*$/, '');
}

export const getSuffix = (value: number) =>  {
    let j = value % 10,
        k = value % 100;
    if (j === 1 && k !== 11) {
        return value + "st";
    }
    if (j === 2 && k !== 12) {
        return value + "nd";
    }
    if (j === 3 && k !== 13) {
        return value + "rd";
    }
    return value + "th";
}

export const interpolateColor = (color?: string) => color ? ` neu-${color} neu-text-${color}` : '';

export const currencyValue =  (value: string) => {
    let returnValue: Array<string> = [];
    if(value !== null && value !== '' && !Number.isNaN(Number(value))){
        const updatedValue: string = Number(value).toFixed(2).toString();
        returnValue = updatedValue.split('.')
    } else if(value === ''){
        returnValue = ['BLANK'];
    } else if(value === null){
        returnValue = [''];
    } else if(value === '-'){
        returnValue = ['-'];
    } else {
        returnValue = [value];
    }
    return returnValue;
}

export const formatAccountNumberForUrl = (accountNumber: string) => Number(accountNumber.replaceAll(/[^0-9]/g, '')).toString();

export const getNodeIds = (nodes: IRoot[]) => {
    let ids: string[] = [];
    nodes?.forEach(({ value, children }: any) => {
        ids = [...ids, value, ...getNodeIds(children)];
    });
    return ids;
};

export  const filterNodeIds = (nodes: IRoot[], allValuesAllowed?: boolean) => {
    var items = getNodeIds(nodes); //get all node ids
    // Exclude string values (market nodes)
    var i = items.length;
    while (i--) {
      var id = items[i];
      const parsed = Number.parseInt(id);
      if (!allValuesAllowed && Number.isNaN(parsed)) {
        items.splice(i, 1);
      }
    }
    items = items.sort((a: any, b: any) => a - b)
    return items;
}

export const getAllNodes = (node: IRoot[], allValuesAllowed?: boolean) => {
    const result: IDropDownItem[] = [];
    if(node) {
        node!.forEach(({ value, label, children }) => {
            result.push({ value, label });
            children?.forEach((child: IRoot) => {
                result.push({ value: child.value!, label: child.label! });
            });
            var i = result.length;
            while (i--) {
                var item = result[i];
                const parsed = Number.parseInt(item.value!);
                if (!allValuesAllowed && Number.isNaN(parsed)) {
                result.splice(i, 1);
                }
            }
        });
    }
    return result;
};

export const filterMultiSelect = (ifaciltymultiselect: IRoot[], facilitylist: string[]): IRoot[] => {
    return ifaciltymultiselect.map(parentNode => {
        const filteredChildren = parentNode.children!.filter(childNode => facilitylist.includes(childNode.value!));
        if (filteredChildren.length > 0) {
        return { ...parentNode, children: filteredChildren };
        }
        return null;
    }).filter(Boolean) as IRoot[];
}

export const extractFacilityId = (
    loadSSCList: any[],
    rowOrCategoryName: any,
    categoryId?: string | number,
    scope?: { sscId?: number; divisionId?: number; facilityId?: number }
): string[]  => {
    if (rowOrCategoryName && typeof rowOrCategoryName === 'object' && rowOrCategoryName.type) {
        const row = rowOrCategoryName;

        if (row.type === 'Facility' && row.facilityId) {
            return [String(row.facilityId)];
        }

        if (row.type === 'Division' && row.divisionId) {
            const ssc = loadSSCList.find((item: any) => item.sscId === row.sscId);
            const division = ssc?.divisions?.find((item: any) => item.divisionId === row.divisionId);
            return (division?.facilities ?? [])
                .map((facility: any) => facility.facilityId)
                .filter(Boolean)
                .sort((a: number, b: number) => a - b)
                .map((facilityId: number) => String(facilityId));
        }

        if (row.type === 'SSC' && row.sscId) {
            const ssc = loadSSCList.find((item: any) => item.sscId === row.sscId);
            return (ssc?.divisions ?? [])
                .flatMap((division: any) => division.facilities ?? [])
                .map((facility: any) => facility.facilityId)
                .filter(Boolean)
                .sort((a: number, b: number) => a - b)
                .map((facilityId: number) => String(facilityId));
        }

        return [];
    }

    const categoryName = rowOrCategoryName;
    const categoryIdNumber = +categoryId!;
    const facilityIds = loadSSCList
      .flatMap((ssc: any) =>
        (ssc.divisions || [])
        .flatMap((division: any) =>
            division.facilities?.filter(
            (facility: any) =>
                facility[categoryName as keyof Facility] === categoryIdNumber &&
                (scope?.sscId === undefined || facility.sscId === scope.sscId) &&
                (scope?.divisionId === undefined || facility.divisionId === scope.divisionId) &&
                (scope?.facilityId === undefined || facility.facilityId === scope.facilityId)
            )
        )
      )
      .map((facility: any) => facility?.facilityId!.toString());

      let uniqueFacilityIds:any = [];
      facilityIds.forEach((element: string) => {
          if (!uniqueFacilityIds.includes(element)) {
              uniqueFacilityIds.push(element);
          }
      });
    return uniqueFacilityIds;
};

export const isEmptyObject = (obj: Record<string, any>): boolean => {
    return Object.getOwnPropertyNames(obj).length === 0;
}

export const isValidDate = (dateStr: string) => {
  // Match MM/DD/YYYY format
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = dateStr.match(regex);

  if (!match) return false;

  const month = parseInt(match[1], 10);
  const day = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);

  // Months in JS Date are 0-based (0 = Jan, 11 = Dec)
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}

export const splitDateRange = (rangeStr: string) => {
  // Split by " - " with optional spaces
  const parts = rangeStr.split(/\s*-\s*/);
  return {
    fromDate: parts[0] || null,
    toDate: parts[1] || null
  };
}

export const IsPastDate = (date?: Date | string | null): boolean => {
    if (!date) return false;
    const d = new Date(date);
    if (isNaN(d.getTime())) return false;
    return d.getTime() < Date.now();
}

/** If we get an network error with no response at all, that usually means a transient network error with Apigee which we should retry */
export const isTransientApigeeNetworkError = (error: AxiosError) => 
  error.code === "ERR_NETWORK" && error.message === "Network Error" && !error.request.response && !error.response;

export const shouldRetryAxiosRequest = (error: AxiosError) => error.response?.status === 503 || isTransientApigeeNetworkError(error);

// export const DateToLocalWithOffset = (date: Date) => {
//   const tzOffset = -date.getTimezoneOffset();
//   const sign = tzOffset >= 0 ? '+' : '-';
//   const pad = (n: number) => String(Math.floor(Math.abs(n))).padStart(2, '0');
//   return (
//     date.getFullYear() + '-' +
//     pad(date.getMonth() + 1) + '-' +
//     pad(date.getDate()) + 'T' +
//     pad(date.getHours()) + ':' +
//     pad(date.getMinutes()) + ':' +
//     pad(date.getSeconds()) +
//     sign + pad(tzOffset / 60) + ':' + pad(tzOffset % 60)
//   );
// }

export const DateToLocalWithoutOffset = (date: Date) => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    date.getFullYear() + '-' +
    pad(date.getMonth() + 1) + '-' +
    pad(date.getDate()) + 'T' +
    pad(date.getHours()) + ':' +
    pad(date.getMinutes()) + ':' +
    pad(date.getSeconds())
  );
};

export const getCleanErrorMessage = (error: string): string => {
    if (!error) return "Something went wrong";
    // Split by \r and remove empty lines
    const parts = error.split("\r").map(p => p.trim()).filter(Boolean);
    // Return the last meaningful part
    return parts.length ? parts[parts.length - 1] : "Something went wrong";
};
